/**
 * ShopHours — compact «График работы магазина» line (ТЗ №7).
 *
 * Renders the server-authoritative ``me.shop_hours_text`` with a small clock glyph and an
 * open/closed dot reflecting ``me.shop_is_open``. When no schedule is configured (``""``),
 * the block renders nothing.
 */
import type { Me } from "@entities/user";

import styles from "./ShopHours.module.css";

export interface ShopHoursProps {
  readonly me: Pick<Me, "shop_hours_text" | "shop_is_open">;
}

const ClockIcon = (): JSX.Element => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);

export function ShopHours({ me }: ShopHoursProps): JSX.Element | null {
  const hours = me.shop_hours_text.trim();
  if (hours.length === 0) {
    return null;
  }

  return (
    <div className={styles.row}>
      <span className={styles.icon} aria-hidden="true">
        <ClockIcon />
      </span>
      <span className={styles.text}>{hours}</span>
      <span
        className={styles.dot}
        data-open={me.shop_is_open ? "true" : "false"}
        aria-hidden="true"
      />
      <span className={styles.state}>
        {me.shop_is_open ? "Открыто" : "Закрыто"}
      </span>
    </div>
  );
}
